// extracted by mini-css-extract-plugin
module.exports = {"icomoon-font":"CookieConsent_icomoon-font__1EjMr","CookieConsent":"CookieConsent_CookieConsent__1Rhga","Content":"CookieConsent_Content__1dYpw"};